import { render, staticRenderFns } from "./netin.vue?vue&type=template&id=f4cf8d88&scoped=true&"
import script from "./netin.vue?vue&type=script&lang=js&"
export * from "./netin.vue?vue&type=script&lang=js&"
import style0 from "./netin.scss?vue&type=style&index=0&id=f4cf8d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cf8d88",
  null
  
)

export default component.exports